!(function () {
  "use strict";
  var e,
    t,
    n,
    r,
    i = !1,
    o = !1,
    a = [];
  function s(e) {
    !(function (e) {
      a.includes(e) || a.push(e);
      o || i || ((i = !0), queueMicrotask(c));
    })(e);
  }
  function l(e) {
    let t = a.indexOf(e);
    -1 !== t && a.splice(t, 1);
  }
  function c() {
    (i = !1), (o = !0);
    for (let e = 0; e < a.length; e++) a[e]();
    (a.length = 0), (o = !1);
  }
  var u = !0;
  function f(e) {
    t = e;
  }
  var d = [],
    p = [],
    _ = [];
  function h(e, t) {
    "function" == typeof t
      ? (e._x_cleanups || (e._x_cleanups = []), e._x_cleanups.push(t))
      : ((t = e), p.push(t));
  }
  function m(e, t) {
    e._x_attributeCleanups &&
      Object.entries(e._x_attributeCleanups).forEach(([n, r]) => {
        (void 0 === t || t.includes(n)) &&
          (r.forEach((e) => e()), delete e._x_attributeCleanups[n]);
      });
  }
  var x = new MutationObserver(O),
    g = !1;
  function v() {
    x.observe(document, {
      subtree: !0,
      childList: !0,
      attributes: !0,
      attributeOldValue: !0,
    }),
      (g = !0);
  }
  function y() {
    (b = b.concat(x.takeRecords())).length &&
      !w &&
      ((w = !0),
      queueMicrotask(() => {
        O(b), (b.length = 0), (w = !1);
      })),
      x.disconnect(),
      (g = !1);
  }
  var b = [],
    w = !1;
  function E(e) {
    if (!g) return e();
    y();
    let t = e();
    return v(), t;
  }
  var k = !1,
    A = [];
  function O(e) {
    if (k) return void (A = A.concat(e));
    let t = [],
      n = [],
      r = new Map(),
      i = new Map();
    for (let o = 0; o < e.length; o++)
      if (
        !e[o].target._x_ignoreMutationObserver &&
        ("childList" === e[o].type &&
          (e[o].addedNodes.forEach((e) => 1 === e.nodeType && t.push(e)),
          e[o].removedNodes.forEach((e) => 1 === e.nodeType && n.push(e))),
        "attributes" === e[o].type)
      ) {
        let t = e[o].target,
          n = e[o].attributeName,
          a = e[o].oldValue,
          s = () => {
            r.has(t) || r.set(t, []),
              r.get(t).push({ name: n, value: t.getAttribute(n) });
          },
          l = () => {
            i.has(t) || i.set(t, []), i.get(t).push(n);
          };
        t.hasAttribute(n) && null === a
          ? s()
          : t.hasAttribute(n)
          ? (l(), s())
          : l();
      }
    i.forEach((e, t) => {
      m(t, e);
    }),
      r.forEach((e, t) => {
        d.forEach((n) => n(t, e));
      });
    for (let e of n)
      if (!t.includes(e) && (p.forEach((t) => t(e)), e._x_cleanups))
        for (; e._x_cleanups.length; ) e._x_cleanups.pop()();
    t.forEach((e) => {
      (e._x_ignoreSelf = !0), (e._x_ignore = !0);
    });
    for (let e of t)
      n.includes(e) ||
        (e.isConnected &&
          (delete e._x_ignoreSelf,
          delete e._x_ignore,
          _.forEach((t) => t(e)),
          (e._x_ignore = !0),
          (e._x_ignoreSelf = !0)));
    t.forEach((e) => {
      delete e._x_ignoreSelf, delete e._x_ignore;
    }),
      (t = null),
      (n = null),
      (r = null),
      (i = null);
  }
  function S(e) {
    return M(j(e));
  }
  function C(e, t, n) {
    return (
      (e._x_dataStack = [t, ...j(n || e)]),
      () => {
        e._x_dataStack = e._x_dataStack.filter((e) => e !== t);
      }
    );
  }
  function $(e, t) {
    let n = e._x_dataStack[0];
    Object.entries(t).forEach(([e, t]) => {
      n[e] = t;
    });
  }
  function j(e) {
    return e._x_dataStack
      ? e._x_dataStack
      : "function" == typeof ShadowRoot && e instanceof ShadowRoot
      ? j(e.host)
      : e.parentNode
      ? j(e.parentNode)
      : [];
  }
  function M(e) {
    let t = new Proxy(
      {},
      {
        ownKeys: () => Array.from(new Set(e.flatMap((e) => Object.keys(e)))),
        has: (t, n) => e.some((e) => e.hasOwnProperty(n)),
        get: (n, r) =>
          (e.find((e) => {
            if (e.hasOwnProperty(r)) {
              let n = Object.getOwnPropertyDescriptor(e, r);
              if (
                (n.get && n.get._x_alreadyBound) ||
                (n.set && n.set._x_alreadyBound)
              )
                return !0;
              if ((n.get || n.set) && n.enumerable) {
                let i = n.get,
                  o = n.set,
                  a = n;
                (i = i && i.bind(t)),
                  (o = o && o.bind(t)),
                  i && (i._x_alreadyBound = !0),
                  o && (o._x_alreadyBound = !0),
                  Object.defineProperty(e, r, { ...a, get: i, set: o });
              }
              return !0;
            }
            return !1;
          }) || {})[r],
        set: (t, n, r) => {
          let i = e.find((e) => e.hasOwnProperty(n));
          return i ? (i[n] = r) : (e[e.length - 1][n] = r), !0;
        },
      }
    );
    return t;
  }
  function L(e) {
    let t = (n, r = "") => {
      Object.entries(Object.getOwnPropertyDescriptors(n)).forEach(
        ([i, { value: o, enumerable: a }]) => {
          if (!1 === a || void 0 === o) return;
          let s = "" === r ? i : `${r}.${i}`;
          var l;
          "object" == typeof o && null !== o && o._x_interceptor
            ? (n[i] = o.initialize(e, s, i))
            : "object" != typeof (l = o) ||
              Array.isArray(l) ||
              null === l ||
              o === n ||
              o instanceof Element ||
              t(o, s);
        }
      );
    };
    return t(e);
  }
  function N(e, t = () => {}) {
    let n = {
      initialValue: void 0,
      _x_interceptor: !0,
      initialize(t, n, r) {
        return e(
          this.initialValue,
          () =>
            (function (e, t) {
              return t.split(".").reduce((e, t) => e[t], e);
            })(t, n),
          (e) => P(t, n, e),
          n,
          r
        );
      },
    };
    return (
      t(n),
      (e) => {
        if ("object" == typeof e && null !== e && e._x_interceptor) {
          let t = n.initialize.bind(n);
          n.initialize = (r, i, o) => {
            let a = e.initialize(r, i, o);
            return (n.initialValue = a), t(r, i, o);
          };
        } else n.initialValue = e;
        return n;
      }
    );
  }
  function P(e, t, n) {
    if (("string" == typeof t && (t = t.split(".")), 1 !== t.length)) {
      if (0 === t.length) throw error;
      return e[t[0]] || (e[t[0]] = {}), P(e[t[0]], t.slice(1), n);
    }
    e[t[0]] = n;
  }
  var T = {};
  function R(e, t) {
    T[e] = t;
  }
  function z(e, t) {
    return (
      Object.entries(T).forEach(([n, r]) => {
        Object.defineProperty(e, `$${n}`, {
          get() {
            let [e, n] = ne(t);
            return (e = { interceptor: N, ...e }), h(t, n), r(t, e);
          },
          enumerable: !1,
        });
      }),
      e
    );
  }
  function I(e, t, n, ...r) {
    try {
      return n(...r);
    } catch (n) {
      D(n, e, t);
    }
  }
  function D(e, t, n) {
    Object.assign(e, { el: t, expression: n }),
      console.warn(
        `Alpine Expression Error: ${e.message}\n\n${
          n ? 'Expression: "' + n + '"\n\n' : ""
        }`,
        t
      ),
      setTimeout(() => {
        throw e;
      }, 0);
  }
  var q = !0;
  function W(e, t, n = {}) {
    let r;
    return B(e, t)((e) => (r = e), n), r;
  }
  function B(...e) {
    return F(...e);
  }
  var F = V;
  function V(e, t) {
    let n = {};
    z(n, e);
    let r = [n, ...j(e)];
    if ("function" == typeof t)
      return (function (e, t) {
        return (n = () => {}, { scope: r = {}, params: i = [] } = {}) => {
          U(n, t.apply(M([r, ...e]), i));
        };
      })(r, t);
    let i = (function (e, t, n) {
      let r = (function (e, t) {
        if (K[e]) return K[e];
        let n = Object.getPrototypeOf(async function () {}).constructor,
          r =
            /^[\n\s]*if.*\(.*\)/.test(e) || /^(let|const)\s/.test(e)
              ? `(() => { ${e} })()`
              : e;
        let i = (() => {
          try {
            return new n(
              ["__self", "scope"],
              `with (scope) { __self.result = ${r} }; __self.finished = true; return __self.result;`
            );
          } catch (n) {
            return D(n, t, e), Promise.resolve();
          }
        })();
        return (K[e] = i), i;
      })(t, n);
      return (i = () => {}, { scope: o = {}, params: a = [] } = {}) => {
        (r.result = void 0), (r.finished = !1);
        let s = M([o, ...e]);
        if ("function" == typeof r) {
          let e = r(r, s).catch((e) => D(e, n, t));
          r.finished
            ? (U(i, r.result, s, a, n), (r.result = void 0))
            : e
                .then((e) => {
                  U(i, e, s, a, n);
                })
                .catch((e) => D(e, n, t))
                .finally(() => (r.result = void 0));
        }
      };
    })(r, t, e);
    return I.bind(null, e, t, i);
  }
  var K = {};
  function U(e, t, n, r, i) {
    if (q && "function" == typeof t) {
      let o = t.apply(n, r);
      o instanceof Promise
        ? o.then((t) => U(e, t, n, r)).catch((e) => D(e, i, t))
        : e(o);
    } else e(t);
  }
  var H = "x-";
  function Z(e = "") {
    return H + e;
  }
  var J = {};
  function Y(e, t) {
    J[e] = t;
  }
  function Q(e, t, n) {
    if (((t = Array.from(t)), e._x_virtualDirectives)) {
      let n = Object.entries(e._x_virtualDirectives).map(([e, t]) => ({
          name: e,
          value: t,
        })),
        r = G(n);
      (n = n.map((e) =>
        r.find((t) => t.name === e.name)
          ? { name: `x-bind:${e.name}`, value: `"${e.value}"` }
          : e
      )),
        (t = t.concat(n));
    }
    let r = {},
      i = t
        .map(ie((e, t) => (r[e] = t)))
        .filter(se)
        .map(
          (function (e, t) {
            return ({ name: n, value: r }) => {
              let i = n.match(le()),
                o = n.match(/:([a-zA-Z0-9\-:]+)/),
                a = n.match(/\.[^.\]]+(?=[^\]]*$)/g) || [],
                s = t || e[n] || n;
              return {
                type: i ? i[1] : null,
                value: o ? o[1] : null,
                modifiers: a.map((e) => e.replace(".", "")),
                expression: r,
                original: s,
              };
            };
          })(r, n)
        )
        .sort(fe);
    return i.map((t) =>
      (function (e, t) {
        let n = () => {},
          r = J[t.type] || n,
          [i, o] = ne(e);
        !(function (e, t, n) {
          e._x_attributeCleanups || (e._x_attributeCleanups = {}),
            e._x_attributeCleanups[t] || (e._x_attributeCleanups[t] = []),
            e._x_attributeCleanups[t].push(n);
        })(e, t.original, o);
        let a = () => {
          e._x_ignore ||
            e._x_ignoreSelf ||
            (r.inline && r.inline(e, t, i),
            (r = r.bind(r, e, t, i)),
            X ? ee.get(te).push(r) : r());
        };
        return (a.runCleanups = o), a;
      })(e, t)
    );
  }
  function G(e) {
    return Array.from(e)
      .map(ie())
      .filter((e) => !se(e));
  }
  var X = !1,
    ee = new Map(),
    te = Symbol();
  function ne(e) {
    let r = [],
      [i, o] = (function (e) {
        let r = () => {};
        return [
          (i) => {
            let o = t(i);
            return (
              e._x_effects ||
                ((e._x_effects = new Set()),
                (e._x_runEffects = () => {
                  e._x_effects.forEach((e) => e());
                })),
              e._x_effects.add(o),
              (r = () => {
                void 0 !== o && (e._x_effects.delete(o), n(o));
              }),
              o
            );
          },
          () => {
            r();
          },
        ];
      })(e);
    r.push(o);
    return [
      {
        Alpine: Ze,
        effect: i,
        cleanup: (e) => r.push(e),
        evaluateLater: B.bind(B, e),
        evaluate: W.bind(W, e),
      },
      () => r.forEach((e) => e()),
    ];
  }
  var re =
    (e, t) =>
    ({ name: n, value: r }) => (
      n.startsWith(e) && (n = n.replace(e, t)), { name: n, value: r }
    );
  function ie(e = () => {}) {
    return ({ name: t, value: n }) => {
      let { name: r, value: i } = oe.reduce((e, t) => t(e), {
        name: t,
        value: n,
      });
      return r !== t && e(r, t), { name: r, value: i };
    };
  }
  var oe = [];
  function ae(e) {
    oe.push(e);
  }
  function se({ name: e }) {
    return le().test(e);
  }
  var le = () => new RegExp(`^${H}([^:^.]+)\\b`);
  var ce = "DEFAULT",
    ue = [
      "ignore",
      "ref",
      "data",
      "id",
      "tabs",
      "radio",
      "switch",
      "disclosure",
      "bind",
      "init",
      "for",
      "mask",
      "model",
      "modelable",
      "transition",
      "show",
      "if",
      ce,
      "teleport",
    ];
  function fe(e, t) {
    let n = -1 === ue.indexOf(e.type) ? ce : e.type,
      r = -1 === ue.indexOf(t.type) ? ce : t.type;
    return ue.indexOf(n) - ue.indexOf(r);
  }
  function de(e, t, n = {}) {
    e.dispatchEvent(
      new CustomEvent(t, {
        detail: n,
        bubbles: !0,
        composed: !0,
        cancelable: !0,
      })
    );
  }
  var pe = [],
    _e = !1;
  function he(e = () => {}) {
    return (
      queueMicrotask(() => {
        _e ||
          setTimeout(() => {
            me();
          });
      }),
      new Promise((t) => {
        pe.push(() => {
          e(), t();
        });
      })
    );
  }
  function me() {
    for (_e = !1; pe.length; ) pe.shift()();
  }
  function xe(e, t) {
    if ("function" == typeof ShadowRoot && e instanceof ShadowRoot)
      return void Array.from(e.children).forEach((e) => xe(e, t));
    let n = !1;
    if ((t(e, () => (n = !0)), n)) return;
    let r = e.firstElementChild;
    for (; r; ) xe(r, t), (r = r.nextElementSibling);
  }
  function ge(e, ...t) {
    console.warn(`Alpine Warning: ${e}`, ...t);
  }
  var ve = [],
    ye = [];
  function be() {
    return ve.map((e) => e());
  }
  function we() {
    return ve.concat(ye).map((e) => e());
  }
  function Ee(e) {
    ve.push(e);
  }
  function ke(e) {
    ye.push(e);
  }
  function Ae(e, t = !1) {
    return Oe(e, (e) => {
      if ((t ? we() : be()).some((t) => e.matches(t))) return !0;
    });
  }
  function Oe(e, t) {
    if (e) {
      if (t(e)) return e;
      if ((e._x_teleportBack && (e = e._x_teleportBack), e.parentElement))
        return Oe(e.parentElement, t);
    }
  }
  function Se(e, t = xe) {
    !(function (e) {
      X = !0;
      let t = Symbol();
      (te = t), ee.set(t, []);
      let n = () => {
        for (; ee.get(t).length; ) ee.get(t).shift()();
        ee.delete(t);
      };
      e(n), (X = !1), n();
    })(() => {
      t(e, (e, t) => {
        Q(e, e.attributes).forEach((e) => e()), e._x_ignore && t();
      });
    });
  }
  function Ce(e, t) {
    return Array.isArray(t)
      ? $e(e, t.join(" "))
      : "object" == typeof t && null !== t
      ? (function (e, t) {
          let n = (e) => e.split(" ").filter(Boolean),
            r = Object.entries(t)
              .flatMap(([e, t]) => !!t && n(e))
              .filter(Boolean),
            i = Object.entries(t)
              .flatMap(([e, t]) => !t && n(e))
              .filter(Boolean),
            o = [],
            a = [];
          return (
            i.forEach((t) => {
              e.classList.contains(t) && (e.classList.remove(t), a.push(t));
            }),
            r.forEach((t) => {
              e.classList.contains(t) || (e.classList.add(t), o.push(t));
            }),
            () => {
              a.forEach((t) => e.classList.add(t)),
                o.forEach((t) => e.classList.remove(t));
            }
          );
        })(e, t)
      : "function" == typeof t
      ? Ce(e, t())
      : $e(e, t);
  }
  function $e(e, t) {
    return (
      (t = !0 === t ? (t = "") : t || ""),
      (n = t
        .split(" ")
        .filter((t) => !e.classList.contains(t))
        .filter(Boolean)),
      e.classList.add(...n),
      () => {
        e.classList.remove(...n);
      }
    );
    var n;
  }
  function je(e, t) {
    return "object" == typeof t && null !== t
      ? (function (e, t) {
          let n = {};
          return (
            Object.entries(t).forEach(([t, r]) => {
              (n[t] = e.style[t]),
                t.startsWith("--") ||
                  (t = t.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()),
                e.style.setProperty(t, r);
            }),
            setTimeout(() => {
              0 === e.style.length && e.removeAttribute("style");
            }),
            () => {
              je(e, n);
            }
          );
        })(e, t)
      : (function (e, t) {
          let n = e.getAttribute("style", t);
          return (
            e.setAttribute("style", t),
            () => {
              e.setAttribute("style", n || "");
            }
          );
        })(e, t);
  }
  function Me(e, t = () => {}) {
    let n = !1;
    return function () {
      n ? t.apply(this, arguments) : ((n = !0), e.apply(this, arguments));
    };
  }
  function Le(e, t, n = {}) {
    e._x_transition ||
      (e._x_transition = {
        enter: { during: n, start: n, end: n },
        leave: { during: n, start: n, end: n },
        in(n = () => {}, r = () => {}) {
          Pe(
            e,
            t,
            {
              during: this.enter.during,
              start: this.enter.start,
              end: this.enter.end,
            },
            n,
            r
          );
        },
        out(n = () => {}, r = () => {}) {
          Pe(
            e,
            t,
            {
              during: this.leave.during,
              start: this.leave.start,
              end: this.leave.end,
            },
            n,
            r
          );
        },
      });
  }
  function Ne(e) {
    let t = e.parentNode;
    if (t) return t._x_hidePromise ? t : Ne(t);
  }
  function Pe(
    e,
    t,
    { during: n, start: r, end: i } = {},
    o = () => {},
    a = () => {}
  ) {
    if (
      (e._x_transitioning && e._x_transitioning.cancel(),
      0 === Object.keys(n).length &&
        0 === Object.keys(r).length &&
        0 === Object.keys(i).length)
    )
      return o(), void a();
    let s, l, c;
    !(function (e, t) {
      let n,
        r,
        i,
        o = Me(() => {
          E(() => {
            (n = !0),
              r || t.before(),
              i || (t.end(), me()),
              t.after(),
              e.isConnected && t.cleanup(),
              delete e._x_transitioning;
          });
        });
      (e._x_transitioning = {
        beforeCancels: [],
        beforeCancel(e) {
          this.beforeCancels.push(e);
        },
        cancel: Me(function () {
          for (; this.beforeCancels.length; ) this.beforeCancels.shift()();
          o();
        }),
        finish: o,
      }),
        E(() => {
          t.start(), t.during();
        }),
        (_e = !0),
        requestAnimationFrame(() => {
          if (n) return;
          let o =
              1e3 *
              Number(
                getComputedStyle(e)
                  .transitionDuration.replace(/,.*/, "")
                  .replace("s", "")
              ),
            a =
              1e3 *
              Number(
                getComputedStyle(e)
                  .transitionDelay.replace(/,.*/, "")
                  .replace("s", "")
              );
          0 === o &&
            (o =
              1e3 *
              Number(getComputedStyle(e).animationDuration.replace("s", ""))),
            E(() => {
              t.before();
            }),
            (r = !0),
            requestAnimationFrame(() => {
              n ||
                (E(() => {
                  t.end();
                }),
                me(),
                setTimeout(e._x_transitioning.finish, o + a),
                (i = !0));
            });
        });
    })(e, {
      start() {
        s = t(e, r);
      },
      during() {
        l = t(e, n);
      },
      before: o,
      end() {
        s(), (c = t(e, i));
      },
      after: a,
      cleanup() {
        l(), c();
      },
    });
  }
  function Te(e, t, n) {
    if (-1 === e.indexOf(t)) return n;
    const r = e[e.indexOf(t) + 1];
    if (!r) return n;
    if ("scale" === t && isNaN(r)) return n;
    if ("duration" === t) {
      let e = r.match(/([0-9]+)ms/);
      if (e) return e[1];
    }
    return "origin" === t &&
      ["top", "right", "left", "center", "bottom"].includes(e[e.indexOf(t) + 2])
      ? [r, e[e.indexOf(t) + 2]].join(" ")
      : r;
  }
  Y(
    "transition",
    (e, { value: t, modifiers: n, expression: r }, { evaluate: i }) => {
      "function" == typeof r && (r = i(r)),
        r
          ? (function (e, t, n) {
              Le(e, Ce, ""),
                {
                  enter: (t) => {
                    e._x_transition.enter.during = t;
                  },
                  "enter-start": (t) => {
                    e._x_transition.enter.start = t;
                  },
                  "enter-end": (t) => {
                    e._x_transition.enter.end = t;
                  },
                  leave: (t) => {
                    e._x_transition.leave.during = t;
                  },
                  "leave-start": (t) => {
                    e._x_transition.leave.start = t;
                  },
                  "leave-end": (t) => {
                    e._x_transition.leave.end = t;
                  },
                }[n](t);
            })(e, r, t)
          : (function (e, t, n) {
              Le(e, je);
              let r = !t.includes("in") && !t.includes("out") && !n,
                i = r || t.includes("in") || ["enter"].includes(n),
                o = r || t.includes("out") || ["leave"].includes(n);
              t.includes("in") &&
                !r &&
                (t = t.filter((e, n) => n < t.indexOf("out")));
              t.includes("out") &&
                !r &&
                (t = t.filter((e, n) => n > t.indexOf("out")));
              let a = !t.includes("opacity") && !t.includes("scale"),
                s = a || t.includes("opacity"),
                l = a || t.includes("scale"),
                c = s ? 0 : 1,
                u = l ? Te(t, "scale", 95) / 100 : 1,
                f = Te(t, "delay", 0),
                d = Te(t, "origin", "center"),
                p = "opacity, transform",
                _ = Te(t, "duration", 150) / 1e3,
                h = Te(t, "duration", 75) / 1e3,
                m = "cubic-bezier(0.4, 0.0, 0.2, 1)";
              i &&
                ((e._x_transition.enter.during = {
                  transformOrigin: d,
                  transitionDelay: f,
                  transitionProperty: p,
                  transitionDuration: `${_}s`,
                  transitionTimingFunction: m,
                }),
                (e._x_transition.enter.start = {
                  opacity: c,
                  transform: `scale(${u})`,
                }),
                (e._x_transition.enter.end = {
                  opacity: 1,
                  transform: "scale(1)",
                }));
              o &&
                ((e._x_transition.leave.during = {
                  transformOrigin: d,
                  transitionDelay: f,
                  transitionProperty: p,
                  transitionDuration: `${h}s`,
                  transitionTimingFunction: m,
                }),
                (e._x_transition.leave.start = {
                  opacity: 1,
                  transform: "scale(1)",
                }),
                (e._x_transition.leave.end = {
                  opacity: c,
                  transform: `scale(${u})`,
                }));
            })(e, n, t);
    }
  ),
    (window.Element.prototype._x_toggleAndCascadeWithTransitions = function (
      e,
      t,
      n,
      r
    ) {
      const i =
        "visible" === document.visibilityState
          ? requestAnimationFrame
          : setTimeout;
      let o = () => i(n);
      t
        ? e._x_transition && (e._x_transition.enter || e._x_transition.leave)
          ? e._x_transition.enter &&
            (Object.entries(e._x_transition.enter.during).length ||
              Object.entries(e._x_transition.enter.start).length ||
              Object.entries(e._x_transition.enter.end).length)
            ? e._x_transition.in(n)
            : o()
          : e._x_transition
          ? e._x_transition.in(n)
          : o()
        : ((e._x_hidePromise = e._x_transition
            ? new Promise((t, n) => {
                e._x_transition.out(
                  () => {},
                  () => t(r)
                ),
                  e._x_transitioning.beforeCancel(() =>
                    n({ isFromCancelledTransition: !0 })
                  );
              })
            : Promise.resolve(r)),
          queueMicrotask(() => {
            let t = Ne(e);
            t
              ? (t._x_hideChildren || (t._x_hideChildren = []),
                t._x_hideChildren.push(e))
              : i(() => {
                  let t = (e) => {
                    let n = Promise.all([
                      e._x_hidePromise,
                      ...(e._x_hideChildren || []).map(t),
                    ]).then(([e]) => e());
                    return delete e._x_hidePromise, delete e._x_hideChildren, n;
                  };
                  t(e).catch((e) => {
                    if (!e.isFromCancelledTransition) throw e;
                  });
                });
          }));
    });
  var Re = !1;
  function ze(e, t = () => {}) {
    return (...n) => (Re ? t(...n) : e(...n));
  }
  function Ie(t, n, r, i = []) {
    switch (
      (t._x_bindings || (t._x_bindings = e({})),
      (t._x_bindings[n] = r),
      (n = i.includes("camel")
        ? n.toLowerCase().replace(/-(\w)/g, (e, t) => t.toUpperCase())
        : n))
    ) {
      case "value":
        !(function (e, t) {
          if ("radio" === e.type)
            void 0 === e.attributes.value && (e.value = t),
              window.fromModel && (e.checked = De(e.value, t));
          else if ("checkbox" === e.type)
            Number.isInteger(t)
              ? (e.value = t)
              : Number.isInteger(t) ||
                Array.isArray(t) ||
                "boolean" == typeof t ||
                [null, void 0].includes(t)
              ? Array.isArray(t)
                ? (e.checked = t.some((t) => De(t, e.value)))
                : (e.checked = !!t)
              : (e.value = String(t));
          else if ("SELECT" === e.tagName)
            !(function (e, t) {
              const n = [].concat(t).map((e) => e + "");
              Array.from(e.options).forEach((e) => {
                e.selected = n.includes(e.value);
              });
            })(e, t);
          else {
            if (e.value === t) return;
            e.value = t;
          }
        })(t, r);
        break;
      case "style":
        !(function (e, t) {
          e._x_undoAddedStyles && e._x_undoAddedStyles();
          e._x_undoAddedStyles = je(e, t);
        })(t, r);
        break;
      case "class":
        !(function (e, t) {
          e._x_undoAddedClasses && e._x_undoAddedClasses();
          e._x_undoAddedClasses = Ce(e, t);
        })(t, r);
        break;
      default:
        !(function (e, t, n) {
          [null, void 0, !1].includes(n) &&
          (function (e) {
            return ![
              "aria-pressed",
              "aria-checked",
              "aria-expanded",
              "aria-selected",
            ].includes(e);
          })(t)
            ? e.removeAttribute(t)
            : (qe(t) && (n = t),
              (function (e, t, n) {
                e.getAttribute(t) != n && e.setAttribute(t, n);
              })(e, t, n));
        })(t, n, r);
    }
  }
  function De(e, t) {
    return e == t;
  }
  function qe(e) {
    return [
      "disabled",
      "checked",
      "required",
      "readonly",
      "hidden",
      "open",
      "selected",
      "autofocus",
      "itemscope",
      "multiple",
      "novalidate",
      "allowfullscreen",
      "allowpaymentrequest",
      "formnovalidate",
      "autoplay",
      "controls",
      "loop",
      "muted",
      "playsinline",
      "default",
      "ismap",
      "reversed",
      "async",
      "defer",
      "nomodule",
    ].includes(e);
  }
  function We(e, t) {
    var n;
    return function () {
      var r = this,
        i = arguments,
        o = function () {
          (n = null), e.apply(r, i);
        };
      clearTimeout(n), (n = setTimeout(o, t));
    };
  }
  function Be(e, t) {
    let n;
    return function () {
      let r = this,
        i = arguments;
      n || (e.apply(r, i), (n = !0), setTimeout(() => (n = !1), t));
    };
  }
  var Fe = {},
    Ve = !1;
  var Ke = {};
  function Ue(e, t, n) {
    let r = [];
    for (; r.length; ) r.pop()();
    let i = Object.entries(t).map(([e, t]) => ({ name: e, value: t })),
      o = G(i);
    (i = i.map((e) =>
      o.find((t) => t.name === e.name)
        ? { name: `x-bind:${e.name}`, value: `"${e.value}"` }
        : e
    )),
      Q(e, i, n).map((e) => {
        r.push(e.runCleanups), e();
      });
  }
  var He = {};
  var Ze = {
    get reactive() {
      return e;
    },
    get release() {
      return n;
    },
    get effect() {
      return t;
    },
    get raw() {
      return r;
    },
    version: "3.10.4",
    flushAndStopDeferringMutations: function () {
      (k = !1), O(A), (A = []);
    },
    dontAutoEvaluateFunctions: function (e) {
      let t = q;
      (q = !1), e(), (q = t);
    },
    disableEffectScheduling: function (e) {
      (u = !1), e(), (u = !0);
    },
    setReactivityEngine: function (i) {
      (e = i.reactive),
        (n = i.release),
        (t = (e) =>
          i.effect(e, {
            scheduler: (e) => {
              u ? s(e) : e();
            },
          })),
        (r = i.raw);
    },
    closestDataStack: j,
    skipDuringClone: ze,
    addRootSelector: Ee,
    addInitSelector: ke,
    addScopeToNode: C,
    deferMutations: function () {
      k = !0;
    },
    mapAttributes: ae,
    evaluateLater: B,
    setEvaluator: function (e) {
      F = e;
    },
    mergeProxies: M,
    findClosest: Oe,
    closestRoot: Ae,
    interceptor: N,
    transition: Pe,
    setStyles: je,
    mutateDom: E,
    directive: Y,
    throttle: Be,
    debounce: We,
    evaluate: W,
    initTree: Se,
    nextTick: he,
    prefixed: Z,
    prefix: function (e) {
      H = e;
    },
    plugin: function (e) {
      e(Ze);
    },
    magic: R,
    store: function (t, n) {
      if ((Ve || ((Fe = e(Fe)), (Ve = !0)), void 0 === n)) return Fe[t];
      (Fe[t] = n),
        "object" == typeof n &&
          null !== n &&
          n.hasOwnProperty("init") &&
          "function" == typeof n.init &&
          Fe[t].init(),
        L(Fe[t]);
    },
    start: function () {
      var e;
      document.body ||
        ge(
          "Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?"
        ),
        de(document, "alpine:init"),
        de(document, "alpine:initializing"),
        v(),
        (e = (e) => Se(e, xe)),
        _.push(e),
        h((e) => {
          xe(e, (e) => m(e));
        }),
        (function (e) {
          d.push(e);
        })((e, t) => {
          Q(e, t).forEach((e) => e());
        }),
        Array.from(document.querySelectorAll(we()))
          .filter((e) => !Ae(e.parentElement, !0))
          .forEach((e) => {
            Se(e);
          }),
        de(document, "alpine:initialized");
    },
    clone: function (e, r) {
      r._x_dataStack || (r._x_dataStack = e._x_dataStack),
        (Re = !0),
        (function (e) {
          let r = t;
          f((e, t) => {
            let i = r(e);
            return n(i), () => {};
          }),
            e(),
            f(r);
        })(() => {
          !(function (e) {
            let t = !1;
            Se(e, (e, n) => {
              xe(e, (e, r) => {
                if (
                  t &&
                  (function (e) {
                    return be().some((t) => e.matches(t));
                  })(e)
                )
                  return r();
                (t = !0), n(e, r);
              });
            });
          })(r);
        }),
        (Re = !1);
    },
    bound: function (e, t, n) {
      if (e._x_bindings && void 0 !== e._x_bindings[t]) return e._x_bindings[t];
      let r = e.getAttribute(t);
      return null === r
        ? "function" == typeof n
          ? n()
          : n
        : "" === r || (qe(t) ? !![t, "true"].includes(r) : r);
    },
    $data: S,
    data: function (e, t) {
      He[e] = t;
    },
    bind: function (e, t) {
      let n = "function" != typeof t ? () => t : t;
      e instanceof Element ? Ue(e, n()) : (Ke[e] = n);
    },
  };
  function Je(e, t) {
    const n = Object.create(null),
      r = e.split(",");
    for (let e = 0; e < r.length; e++) n[r[e]] = !0;
    return t ? (e) => !!n[e.toLowerCase()] : (e) => !!n[e];
  }
  var Ye,
    Qe = Object.freeze({}),
    Ge = (Object.freeze([]), Object.assign),
    Xe = Object.prototype.hasOwnProperty,
    et = (e, t) => Xe.call(e, t),
    tt = Array.isArray,
    nt = (e) => "[object Map]" === at(e),
    rt = (e) => "symbol" == typeof e,
    it = (e) => null !== e && "object" == typeof e,
    ot = Object.prototype.toString,
    at = (e) => ot.call(e),
    st = (e) => at(e).slice(8, -1),
    lt = (e) =>
      "string" == typeof e &&
      "NaN" !== e &&
      "-" !== e[0] &&
      "" + parseInt(e, 10) === e,
    ct = (e) => {
      const t = Object.create(null);
      return (n) => t[n] || (t[n] = e(n));
    },
    ut = /-(\w)/g,
    ft =
      (ct((e) => e.replace(ut, (e, t) => (t ? t.toUpperCase() : ""))),
      /\B([A-Z])/g),
    dt =
      (ct((e) => e.replace(ft, "-$1").toLowerCase()),
      ct((e) => e.charAt(0).toUpperCase() + e.slice(1))),
    pt =
      (ct((e) => (e ? `on${dt(e)}` : "")),
      (e, t) => e !== t && (e == e || t == t)),
    _t = new WeakMap(),
    ht = [],
    mt = Symbol("iterate"),
    xt = Symbol("Map key iterate");
  var gt = 0;
  function vt(e) {
    const { deps: t } = e;
    if (t.length) {
      for (let n = 0; n < t.length; n++) t[n].delete(e);
      t.length = 0;
    }
  }
  var yt = !0,
    bt = [];
  function wt() {
    const e = bt.pop();
    yt = void 0 === e || e;
  }
  function Et(e, t, n) {
    if (!yt || void 0 === Ye) return;
    let r = _t.get(e);
    r || _t.set(e, (r = new Map()));
    let i = r.get(n);
    i || r.set(n, (i = new Set())),
      i.has(Ye) ||
        (i.add(Ye),
        Ye.deps.push(i),
        Ye.options.onTrack &&
          Ye.options.onTrack({ effect: Ye, target: e, type: t, key: n }));
  }
  function kt(e, t, n, r, i, o) {
    const a = _t.get(e);
    if (!a) return;
    const s = new Set(),
      l = (e) => {
        e &&
          e.forEach((e) => {
            (e !== Ye || e.allowRecurse) && s.add(e);
          });
      };
    if ("clear" === t) a.forEach(l);
    else if ("length" === n && tt(e))
      a.forEach((e, t) => {
        ("length" === t || t >= r) && l(e);
      });
    else
      switch ((void 0 !== n && l(a.get(n)), t)) {
        case "add":
          tt(e)
            ? lt(n) && l(a.get("length"))
            : (l(a.get(mt)), nt(e) && l(a.get(xt)));
          break;
        case "delete":
          tt(e) || (l(a.get(mt)), nt(e) && l(a.get(xt)));
          break;
        case "set":
          nt(e) && l(a.get(mt));
      }
    s.forEach((a) => {
      a.options.onTrigger &&
        a.options.onTrigger({
          effect: a,
          target: e,
          key: n,
          type: t,
          newValue: r,
          oldValue: i,
          oldTarget: o,
        }),
        a.options.scheduler ? a.options.scheduler(a) : a();
    });
  }
  var At = Je("__proto__,__v_isRef,__isVue"),
    Ot = new Set(
      Object.getOwnPropertyNames(Symbol)
        .map((e) => Symbol[e])
        .filter(rt)
    ),
    St = Lt(),
    Ct = Lt(!1, !0),
    $t = Lt(!0),
    jt = Lt(!0, !0),
    Mt = {};
  function Lt(e = !1, t = !1) {
    return function (n, r, i) {
      if ("__v_isReactive" === r) return !e;
      if ("__v_isReadonly" === r) return e;
      if ("__v_raw" === r && i === (e ? (t ? ln : sn) : t ? an : on).get(n))
        return n;
      const o = tt(n);
      if (!e && o && et(Mt, r)) return Reflect.get(Mt, r, i);
      const a = Reflect.get(n, r, i);
      if (rt(r) ? Ot.has(r) : At(r)) return a;
      if ((e || Et(n, "get", r), t)) return a;
      if (pn(a)) {
        return !o || !lt(r) ? a.value : a;
      }
      return it(a) ? (e ? un(a) : cn(a)) : a;
    };
  }
  function Nt(e = !1) {
    return function (t, n, r, i) {
      let o = t[n];
      if (!e && ((r = dn(r)), (o = dn(o)), !tt(t) && pn(o) && !pn(r)))
        return (o.value = r), !0;
      const a = tt(t) && lt(n) ? Number(n) < t.length : et(t, n),
        s = Reflect.set(t, n, r, i);
      return (
        t === dn(i) &&
          (a ? pt(r, o) && kt(t, "set", n, r, o) : kt(t, "add", n, r)),
        s
      );
    };
  }
  ["includes", "indexOf", "lastIndexOf"].forEach((e) => {
    const t = Array.prototype[e];
    Mt[e] = function (...e) {
      const n = dn(this);
      for (let e = 0, t = this.length; e < t; e++) Et(n, "get", e + "");
      const r = t.apply(n, e);
      return -1 === r || !1 === r ? t.apply(n, e.map(dn)) : r;
    };
  }),
    ["push", "pop", "shift", "unshift", "splice"].forEach((e) => {
      const t = Array.prototype[e];
      Mt[e] = function (...e) {
        bt.push(yt), (yt = !1);
        const n = t.apply(this, e);
        return wt(), n;
      };
    });
  var Pt = {
      get: St,
      set: Nt(),
      deleteProperty: function (e, t) {
        const n = et(e, t),
          r = e[t],
          i = Reflect.deleteProperty(e, t);
        return i && n && kt(e, "delete", t, void 0, r), i;
      },
      has: function (e, t) {
        const n = Reflect.has(e, t);
        return (rt(t) && Ot.has(t)) || Et(e, "has", t), n;
      },
      ownKeys: function (e) {
        return Et(e, "iterate", tt(e) ? "length" : mt), Reflect.ownKeys(e);
      },
    },
    Tt = {
      get: $t,
      set(e, t) {
        return (
          console.warn(
            `Set operation on key "${String(t)}" failed: target is readonly.`,
            e
          ),
          !0
        );
      },
      deleteProperty(e, t) {
        return (
          console.warn(
            `Delete operation on key "${String(
              t
            )}" failed: target is readonly.`,
            e
          ),
          !0
        );
      },
    },
    Rt =
      (Ge({}, Pt, { get: Ct, set: Nt(!0) }),
      Ge({}, Tt, { get: jt }),
      (e) => (it(e) ? cn(e) : e)),
    zt = (e) => (it(e) ? un(e) : e),
    It = (e) => e,
    Dt = (e) => Reflect.getPrototypeOf(e);
  function qt(e, t, n = !1, r = !1) {
    const i = dn((e = e.__v_raw)),
      o = dn(t);
    t !== o && !n && Et(i, "get", t), !n && Et(i, "get", o);
    const { has: a } = Dt(i),
      s = r ? It : n ? zt : Rt;
    return a.call(i, t)
      ? s(e.get(t))
      : a.call(i, o)
      ? s(e.get(o))
      : void (e !== i && e.get(t));
  }
  function Wt(e, t = !1) {
    const n = this.__v_raw,
      r = dn(n),
      i = dn(e);
    return (
      e !== i && !t && Et(r, "has", e),
      !t && Et(r, "has", i),
      e === i ? n.has(e) : n.has(e) || n.has(i)
    );
  }
  function Bt(e, t = !1) {
    return (
      (e = e.__v_raw), !t && Et(dn(e), "iterate", mt), Reflect.get(e, "size", e)
    );
  }
  function Ft(e) {
    e = dn(e);
    const t = dn(this);
    return Dt(t).has.call(t, e) || (t.add(e), kt(t, "add", e, e)), this;
  }
  function Vt(e, t) {
    t = dn(t);
    const n = dn(this),
      { has: r, get: i } = Dt(n);
    let o = r.call(n, e);
    o ? rn(n, r, e) : ((e = dn(e)), (o = r.call(n, e)));
    const a = i.call(n, e);
    return (
      n.set(e, t),
      o ? pt(t, a) && kt(n, "set", e, t, a) : kt(n, "add", e, t),
      this
    );
  }
  function Kt(e) {
    const t = dn(this),
      { has: n, get: r } = Dt(t);
    let i = n.call(t, e);
    i ? rn(t, n, e) : ((e = dn(e)), (i = n.call(t, e)));
    const o = r ? r.call(t, e) : void 0,
      a = t.delete(e);
    return i && kt(t, "delete", e, void 0, o), a;
  }
  function Ut() {
    const e = dn(this),
      t = 0 !== e.size,
      n = nt(e) ? new Map(e) : new Set(e),
      r = e.clear();
    return t && kt(e, "clear", void 0, void 0, n), r;
  }
  function Ht(e, t) {
    return function (n, r) {
      const i = this,
        o = i.__v_raw,
        a = dn(o),
        s = t ? It : e ? zt : Rt;
      return (
        !e && Et(a, "iterate", mt),
        o.forEach((e, t) => n.call(r, s(e), s(t), i))
      );
    };
  }
  function Zt(e, t, n) {
    return function (...r) {
      const i = this.__v_raw,
        o = dn(i),
        a = nt(o),
        s = "entries" === e || (e === Symbol.iterator && a),
        l = "keys" === e && a,
        c = i[e](...r),
        u = n ? It : t ? zt : Rt;
      return (
        !t && Et(o, "iterate", l ? xt : mt),
        {
          next() {
            const { value: e, done: t } = c.next();
            return t
              ? { value: e, done: t }
              : { value: s ? [u(e[0]), u(e[1])] : u(e), done: t };
          },
          [Symbol.iterator]() {
            return this;
          },
        }
      );
    };
  }
  function Jt(e) {
    return function (...t) {
      {
        const n = t[0] ? `on key "${t[0]}" ` : "";
        console.warn(
          `${dt(e)} operation ${n}failed: target is readonly.`,
          dn(this)
        );
      }
      return "delete" !== e && this;
    };
  }
  var Yt = {
      get(e) {
        return qt(this, e);
      },
      get size() {
        return Bt(this);
      },
      has: Wt,
      add: Ft,
      set: Vt,
      delete: Kt,
      clear: Ut,
      forEach: Ht(!1, !1),
    },
    Qt = {
      get(e) {
        return qt(this, e, !1, !0);
      },
      get size() {
        return Bt(this);
      },
      has: Wt,
      add: Ft,
      set: Vt,
      delete: Kt,
      clear: Ut,
      forEach: Ht(!1, !0),
    },
    Gt = {
      get(e) {
        return qt(this, e, !0);
      },
      get size() {
        return Bt(this, !0);
      },
      has(e) {
        return Wt.call(this, e, !0);
      },
      add: Jt("add"),
      set: Jt("set"),
      delete: Jt("delete"),
      clear: Jt("clear"),
      forEach: Ht(!0, !1),
    },
    Xt = {
      get(e) {
        return qt(this, e, !0, !0);
      },
      get size() {
        return Bt(this, !0);
      },
      has(e) {
        return Wt.call(this, e, !0);
      },
      add: Jt("add"),
      set: Jt("set"),
      delete: Jt("delete"),
      clear: Jt("clear"),
      forEach: Ht(!0, !0),
    };
  function en(e, t) {
    const n = t ? (e ? Xt : Qt) : e ? Gt : Yt;
    return (t, r, i) =>
      "__v_isReactive" === r
        ? !e
        : "__v_isReadonly" === r
        ? e
        : "__v_raw" === r
        ? t
        : Reflect.get(et(n, r) && r in t ? n : t, r, i);
  }
  ["keys", "values", "entries", Symbol.iterator].forEach((e) => {
    (Yt[e] = Zt(e, !1, !1)),
      (Gt[e] = Zt(e, !0, !1)),
      (Qt[e] = Zt(e, !1, !0)),
      (Xt[e] = Zt(e, !0, !0));
  });
  var tn = { get: en(!1, !1) },
    nn = (en(!1, !0), { get: en(!0, !1) });
  en(!0, !0);
  function rn(e, t, n) {
    const r = dn(n);
    if (r !== n && t.call(e, r)) {
      const t = st(e);
      console.warn(
        `Reactive ${t} contains both the raw and reactive versions of the same object${
          "Map" === t ? " as keys" : ""
        }, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`
      );
    }
  }
  var on = new WeakMap(),
    an = new WeakMap(),
    sn = new WeakMap(),
    ln = new WeakMap();
  function cn(e) {
    return e && e.__v_isReadonly ? e : fn(e, !1, Pt, tn, on);
  }
  function un(e) {
    return fn(e, !0, Tt, nn, sn);
  }
  function fn(e, t, n, r, i) {
    if (!it(e))
      return console.warn(`value cannot be made reactive: ${String(e)}`), e;
    if (e.__v_raw && (!t || !e.__v_isReactive)) return e;
    const o = i.get(e);
    if (o) return o;
    const a =
      (s = e).__v_skip || !Object.isExtensible(s)
        ? 0
        : (function (e) {
            switch (e) {
              case "Object":
              case "Array":
                return 1;
              case "Map":
              case "Set":
              case "WeakMap":
              case "WeakSet":
                return 2;
              default:
                return 0;
            }
          })(st(s));
    var s;
    if (0 === a) return e;
    const l = new Proxy(e, 2 === a ? r : n);
    return i.set(e, l), l;
  }
  function dn(e) {
    return (e && dn(e.__v_raw)) || e;
  }
  function pn(e) {
    return Boolean(e && !0 === e.__v_isRef);
  }
  R("nextTick", () => he),
    R("dispatch", (e) => de.bind(de, e)),
    R("watch", (e, { evaluateLater: t, effect: n }) => (r, i) => {
      let o,
        a = t(r),
        s = !0,
        l = n(() =>
          a((e) => {
            JSON.stringify(e),
              s
                ? (o = e)
                : queueMicrotask(() => {
                    i(e, o), (o = e);
                  }),
              (s = !1);
          })
        );
      e._x_effects.delete(l);
    }),
    R("store", function () {
      return Fe;
    }),
    R("data", (e) => S(e)),
    R("root", (e) => Ae(e)),
    R(
      "refs",
      (e) => (
        e._x_refs_proxy ||
          (e._x_refs_proxy = M(
            (function (e) {
              let t = [],
                n = e;
              for (; n; ) n._x_refs && t.push(n._x_refs), (n = n.parentNode);
              return t;
            })(e)
          )),
        e._x_refs_proxy
      )
    );
  var _n = {};
  function hn(e) {
    return _n[e] || (_n[e] = 0), ++_n[e];
  }
  function mn(e, t, n) {
    R(t, (t) =>
      ge(
        `You can't use [$${directiveName}] without first installing the "${e}" plugin here: https://alpinejs.dev/plugins/${n}`,
        t
      )
    );
  }
  R("id", (e) => (t, n = null) => {
    let r = (function (e, t) {
        return Oe(e, (e) => {
          if (e._x_ids && e._x_ids[t]) return !0;
        });
      })(e, t),
      i = r ? r._x_ids[t] : hn(t);
    return n ? `${t}-${i}-${n}` : `${t}-${i}`;
  }),
    R("el", (e) => e),
    mn("Focus", "focus", "focus"),
    mn("Persist", "persist", "persist"),
    Y("modelable", (e, { expression: t }, { effect: n, evaluateLater: r }) => {
      let i = r(t),
        o = () => {
          let e;
          return i((t) => (e = t)), e;
        },
        a = r(`${t} = __placeholder`),
        s = (e) => a(() => {}, { scope: { __placeholder: e } }),
        l = o();
      s(l),
        queueMicrotask(() => {
          if (!e._x_model) return;
          e._x_removeModelListeners.default();
          let t = e._x_model.get,
            r = e._x_model.set;
          n(() => s(t())), n(() => r(o()));
        });
    }),
    Y("teleport", (e, { expression: t }, { cleanup: n }) => {
      "template" !== e.tagName.toLowerCase() &&
        ge("x-teleport can only be used on a <template> tag", e);
      let r = document.querySelector(t);
      r || ge(`Cannot find x-teleport element for selector: "${t}"`);
      let i = e.content.cloneNode(!0).firstElementChild;
      (e._x_teleport = i),
        (i._x_teleportBack = e),
        e._x_forwardEvents &&
          e._x_forwardEvents.forEach((t) => {
            i.addEventListener(t, (t) => {
              t.stopPropagation(),
                e.dispatchEvent(new t.constructor(t.type, t));
            });
          }),
        C(i, {}, e),
        E(() => {
          r.appendChild(i), Se(i), (i._x_ignore = !0);
        }),
        n(() => i.remove());
    });
  var xn = () => {};
  function gn(e, t, n, r) {
    let i = e,
      o = (e) => r(e),
      a = {},
      s = (e, t) => (n) => t(e, n);
    if (
      (n.includes("dot") && (t = t.replace(/-/g, ".")),
      n.includes("camel") &&
        (t = (function (e) {
          return e.toLowerCase().replace(/-(\w)/g, (e, t) => t.toUpperCase());
        })(t)),
      n.includes("passive") && (a.passive = !0),
      n.includes("capture") && (a.capture = !0),
      n.includes("window") && (i = window),
      n.includes("document") && (i = document),
      n.includes("prevent") &&
        (o = s(o, (e, t) => {
          t.preventDefault(), e(t);
        })),
      n.includes("stop") &&
        (o = s(o, (e, t) => {
          t.stopPropagation(), e(t);
        })),
      n.includes("self") &&
        (o = s(o, (t, n) => {
          n.target === e && t(n);
        })),
      (n.includes("away") || n.includes("outside")) &&
        ((i = document),
        (o = s(o, (t, n) => {
          e.contains(n.target) ||
            (!1 !== n.target.isConnected &&
              ((e.offsetWidth < 1 && e.offsetHeight < 1) ||
                (!1 !== e._x_isShown && t(n))));
        }))),
      n.includes("once") &&
        (o = s(o, (e, n) => {
          e(n), i.removeEventListener(t, o, a);
        })),
      (o = s(o, (e, r) => {
        ((function (e) {
          return ["keydown", "keyup"].includes(e);
        })(t) &&
          (function (e, t) {
            let n = t.filter(
              (e) =>
                !["window", "document", "prevent", "stop", "once"].includes(e)
            );
            if (n.includes("debounce")) {
              let e = n.indexOf("debounce");
              n.splice(
                e,
                vn((n[e + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1
              );
            }
            if (0 === n.length) return !1;
            if (1 === n.length && yn(e.key).includes(n[0])) return !1;
            const r = ["ctrl", "shift", "alt", "meta", "cmd", "super"].filter(
              (e) => n.includes(e)
            );
            if (((n = n.filter((e) => !r.includes(e))), r.length > 0)) {
              if (
                r.filter(
                  (t) => (
                    ("cmd" !== t && "super" !== t) || (t = "meta"), e[`${t}Key`]
                  )
                ).length === r.length &&
                yn(e.key).includes(n[0])
              )
                return !1;
            }
            return !0;
          })(r, n)) ||
          e(r);
      })),
      n.includes("debounce"))
    ) {
      let e = n[n.indexOf("debounce") + 1] || "invalid-wait",
        t = vn(e.split("ms")[0]) ? Number(e.split("ms")[0]) : 250;
      o = We(o, t);
    }
    if (n.includes("throttle")) {
      let e = n[n.indexOf("throttle") + 1] || "invalid-wait",
        t = vn(e.split("ms")[0]) ? Number(e.split("ms")[0]) : 250;
      o = Be(o, t);
    }
    return (
      i.addEventListener(t, o, a),
      () => {
        i.removeEventListener(t, o, a);
      }
    );
  }
  function vn(e) {
    return !Array.isArray(e) && !isNaN(e);
  }
  function yn(e) {
    if (!e) return [];
    e = e
      .replace(/([a-z])([A-Z])/g, "$1-$2")
      .replace(/[_\s]/, "-")
      .toLowerCase();
    let t = {
      ctrl: "control",
      slash: "/",
      space: "-",
      spacebar: "-",
      cmd: "meta",
      esc: "escape",
      up: "arrow-up",
      down: "arrow-down",
      left: "arrow-left",
      right: "arrow-right",
      period: ".",
      equal: "=",
    };
    return (
      (t[e] = e),
      Object.keys(t)
        .map((n) => {
          if (t[n] === e) return n;
        })
        .filter((e) => e)
    );
  }
  function bn(e) {
    let t = e ? parseFloat(e) : null;
    return (n = t), Array.isArray(n) || isNaN(n) ? e : t;
    var n;
  }
  function wn(e, t, n, r) {
    let i = {};
    if (/^\[.*\]$/.test(e.item) && Array.isArray(t)) {
      e.item
        .replace("[", "")
        .replace("]", "")
        .split(",")
        .map((e) => e.trim())
        .forEach((e, n) => {
          i[e] = t[n];
        });
    } else if (
      /^\{.*\}$/.test(e.item) &&
      !Array.isArray(t) &&
      "object" == typeof t
    ) {
      e.item
        .replace("{", "")
        .replace("}", "")
        .split(",")
        .map((e) => e.trim())
        .forEach((e) => {
          i[e] = t[e];
        });
    } else i[e.item] = t;
    return (
      e.index && (i[e.index] = n), e.collection && (i[e.collection] = r), i
    );
  }
  function En() {}
  function kn(e, t, n) {
    Y(t, (r) =>
      ge(
        `You can't use [x-${t}] without first installing the "${e}" plugin here: https://alpinejs.dev/plugins/${n}`,
        r
      )
    );
  }
  (xn.inline = (e, { modifiers: t }, { cleanup: n }) => {
    t.includes("self") ? (e._x_ignoreSelf = !0) : (e._x_ignore = !0),
      n(() => {
        t.includes("self") ? delete e._x_ignoreSelf : delete e._x_ignore;
      });
  }),
    Y("ignore", xn),
    Y("effect", (e, { expression: t }, { effect: n }) => n(B(e, t))),
    Y(
      "model",
      (e, { modifiers: t, expression: n }, { effect: r, cleanup: i }) => {
        let o = B(e, n),
          a = B(e, `${n} = rightSideOfExpression($event, ${n})`);
        var s =
          "select" === e.tagName.toLowerCase() ||
          ["checkbox", "radio"].includes(e.type) ||
          t.includes("lazy")
            ? "change"
            : "input";
        let l = (function (e, t, n) {
            "radio" === e.type &&
              E(() => {
                e.hasAttribute("name") || e.setAttribute("name", n);
              });
            return (n, r) =>
              E(() => {
                if (n instanceof CustomEvent && void 0 !== n.detail)
                  return n.detail || n.target.value;
                if ("checkbox" === e.type) {
                  if (Array.isArray(r)) {
                    let e = t.includes("number")
                      ? bn(n.target.value)
                      : n.target.value;
                    return n.target.checked
                      ? r.concat([e])
                      : r.filter((t) => !(t == e));
                  }
                  return n.target.checked;
                }
                if ("select" === e.tagName.toLowerCase() && e.multiple)
                  return t.includes("number")
                    ? Array.from(n.target.selectedOptions).map((e) =>
                        bn(e.value || e.text)
                      )
                    : Array.from(n.target.selectedOptions).map(
                        (e) => e.value || e.text
                      );
                {
                  let e = n.target.value;
                  return t.includes("number")
                    ? bn(e)
                    : t.includes("trim")
                    ? e.trim()
                    : e;
                }
              });
          })(e, t, n),
          c = gn(e, s, t, (e) => {
            a(() => {}, { scope: { $event: e, rightSideOfExpression: l } });
          });
        e._x_removeModelListeners || (e._x_removeModelListeners = {}),
          (e._x_removeModelListeners.default = c),
          i(() => e._x_removeModelListeners.default());
        let u = B(e, `${n} = __placeholder`);
        (e._x_model = {
          get() {
            let e;
            return o((t) => (e = t)), e;
          },
          set(e) {
            u(() => {}, { scope: { __placeholder: e } });
          },
        }),
          (e._x_forceModelUpdate = () => {
            o((t) => {
              void 0 === t && n.match(/\./) && (t = ""),
                (window.fromModel = !0),
                E(() => Ie(e, "value", t)),
                delete window.fromModel;
            });
          }),
          r(() => {
            (t.includes("unintrusive") &&
              document.activeElement.isSameNode(e)) ||
              e._x_forceModelUpdate();
          });
      }
    ),
    Y("cloak", (e) =>
      queueMicrotask(() => E(() => e.removeAttribute(Z("cloak"))))
    ),
    ke(() => `[${Z("init")}]`),
    Y(
      "init",
      ze((e, { expression: t }, { evaluate: n }) =>
        "string" == typeof t ? !!t.trim() && n(t, {}, !1) : n(t, {}, !1)
      )
    ),
    Y("text", (e, { expression: t }, { effect: n, evaluateLater: r }) => {
      let i = r(t);
      n(() => {
        i((t) => {
          E(() => {
            e.textContent = t;
          });
        });
      });
    }),
    Y("html", (e, { expression: t }, { effect: n, evaluateLater: r }) => {
      let i = r(t);
      n(() => {
        i((t) => {
          E(() => {
            (e.innerHTML = t),
              (e._x_ignoreSelf = !0),
              Se(e),
              delete e._x_ignoreSelf;
          });
        });
      });
    }),
    ae(re(":", Z("bind:"))),
    Y(
      "bind",
      (
        e,
        { value: t, modifiers: n, expression: r, original: i },
        { effect: o }
      ) => {
        if (!t) {
          let t = {};
          return (
            (a = t),
            Object.entries(Ke).forEach(([e, t]) => {
              Object.defineProperty(a, e, {
                get() {
                  return (...e) => t(...e);
                },
              });
            }),
            void B(e, r)(
              (t) => {
                Ue(e, t, i);
              },
              { scope: t }
            )
          );
        }
        var a;
        if ("key" === t)
          return (function (e, t) {
            e._x_keyExpression = t;
          })(e, r);
        let s = B(e, r);
        o(() =>
          s((i) => {
            void 0 === i && "string" == typeof r && r.match(/\./) && (i = ""),
              E(() => Ie(e, t, i, n));
          })
        );
      }
    ),
    Ee(() => `[${Z("data")}]`),
    Y(
      "data",
      ze((t, { expression: n }, { cleanup: r }) => {
        n = "" === n ? "{}" : n;
        let i = {};
        z(i, t);
        let o = {};
        var a, s;
        (a = o),
          (s = i),
          Object.entries(He).forEach(([e, t]) => {
            Object.defineProperty(a, e, {
              get() {
                return (...e) => t.bind(s)(...e);
              },
              enumerable: !1,
            });
          });
        let l = W(t, n, { scope: o });
        void 0 === l && (l = {}), z(l, t);
        let c = e(l);
        L(c);
        let u = C(t, c);
        c.init && W(t, c.init),
          r(() => {
            c.destroy && W(t, c.destroy), u();
          });
      })
    ),
    Y("show", (e, { modifiers: t, expression: n }, { effect: r }) => {
      let i = B(e, n);
      e._x_doHide ||
        (e._x_doHide = () => {
          E(() => {
            e.style.setProperty(
              "display",
              "none",
              t.includes("important") ? "important" : void 0
            );
          });
        }),
        e._x_doShow ||
          (e._x_doShow = () => {
            E(() => {
              1 === e.style.length && "none" === e.style.display
                ? e.removeAttribute("style")
                : e.style.removeProperty("display");
            });
          });
      let o,
        a = () => {
          e._x_doHide(), (e._x_isShown = !1);
        },
        s = () => {
          e._x_doShow(), (e._x_isShown = !0);
        },
        l = () => setTimeout(s),
        c = Me(
          (e) => (e ? s() : a()),
          (t) => {
            "function" == typeof e._x_toggleAndCascadeWithTransitions
              ? e._x_toggleAndCascadeWithTransitions(e, t, s, a)
              : t
              ? l()
              : a();
          }
        ),
        u = !0;
      r(() =>
        i((e) => {
          (u || e !== o) &&
            (t.includes("immediate") && (e ? l() : a()),
            c(e),
            (o = e),
            (u = !1));
        })
      );
    }),
    Y("for", (t, { expression: n }, { effect: r, cleanup: i }) => {
      let o = (function (e) {
          let t = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/,
            n = /^\s*\(|\)\s*$/g,
            r = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/,
            i = e.match(r);
          if (!i) return;
          let o = {};
          o.items = i[2].trim();
          let a = i[1].replace(n, "").trim(),
            s = a.match(t);
          s
            ? ((o.item = a.replace(t, "").trim()),
              (o.index = s[1].trim()),
              s[2] && (o.collection = s[2].trim()))
            : (o.item = a);
          return o;
        })(n),
        a = B(t, o.items),
        s = B(t, t._x_keyExpression || "index");
      (t._x_prevKeys = []),
        (t._x_lookup = {}),
        r(() =>
          (function (t, n, r, i) {
            let o = (e) => "object" == typeof e && !Array.isArray(e),
              a = t;
            r((r) => {
              var s;
              (s = r),
                !Array.isArray(s) &&
                  !isNaN(s) &&
                  r >= 0 &&
                  (r = Array.from(Array(r).keys(), (e) => e + 1)),
                void 0 === r && (r = []);
              let c = t._x_lookup,
                u = t._x_prevKeys,
                f = [],
                d = [];
              if (o(r))
                r = Object.entries(r).map(([e, t]) => {
                  let o = wn(n, t, e, r);
                  i((e) => d.push(e), { scope: { index: e, ...o } }), f.push(o);
                });
              else
                for (let e = 0; e < r.length; e++) {
                  let t = wn(n, r[e], e, r);
                  i((e) => d.push(e), { scope: { index: e, ...t } }), f.push(t);
                }
              let p = [],
                _ = [],
                h = [],
                m = [];
              for (let e = 0; e < u.length; e++) {
                let t = u[e];
                -1 === d.indexOf(t) && h.push(t);
              }
              u = u.filter((e) => !h.includes(e));
              let x = "template";
              for (let e = 0; e < d.length; e++) {
                let t = d[e],
                  n = u.indexOf(t);
                if (-1 === n) u.splice(e, 0, t), p.push([x, e]);
                else if (n !== e) {
                  let t = u.splice(e, 1)[0],
                    r = u.splice(n - 1, 1)[0];
                  u.splice(e, 0, r), u.splice(n, 0, t), _.push([t, r]);
                } else m.push(t);
                x = t;
              }
              for (let e = 0; e < h.length; e++) {
                let t = h[e];
                c[t]._x_effects && c[t]._x_effects.forEach(l),
                  c[t].remove(),
                  (c[t] = null),
                  delete c[t];
              }
              for (let e = 0; e < _.length; e++) {
                let [t, n] = _[e],
                  r = c[t],
                  i = c[n],
                  o = document.createElement("div");
                E(() => {
                  i.after(o),
                    r.after(i),
                    i._x_currentIfEl && i.after(i._x_currentIfEl),
                    o.before(r),
                    r._x_currentIfEl && r.after(r._x_currentIfEl),
                    o.remove();
                }),
                  $(i, f[d.indexOf(n)]);
              }
              for (let t = 0; t < p.length; t++) {
                let [n, r] = p[t],
                  i = "template" === n ? a : c[n];
                i._x_currentIfEl && (i = i._x_currentIfEl);
                let o = f[r],
                  s = d[r],
                  l = document.importNode(a.content, !0).firstElementChild;
                C(l, e(o), a),
                  E(() => {
                    i.after(l), Se(l);
                  }),
                  "object" == typeof s &&
                    ge(
                      "x-for key cannot be an object, it must be a string or an integer",
                      a
                    ),
                  (c[s] = l);
              }
              for (let e = 0; e < m.length; e++) $(c[m[e]], f[d.indexOf(m[e])]);
              a._x_prevKeys = d;
            });
          })(t, o, a, s)
        ),
        i(() => {
          Object.values(t._x_lookup).forEach((e) => e.remove()),
            delete t._x_prevKeys,
            delete t._x_lookup;
        });
    }),
    (En.inline = (e, { expression: t }, { cleanup: n }) => {
      let r = Ae(e);
      r._x_refs || (r._x_refs = {}),
        (r._x_refs[t] = e),
        n(() => delete r._x_refs[t]);
    }),
    Y("ref", En),
    Y("if", (e, { expression: t }, { effect: n, cleanup: r }) => {
      let i = B(e, t);
      n(() =>
        i((t) => {
          t
            ? (() => {
                if (e._x_currentIfEl) return e._x_currentIfEl;
                let t = e.content.cloneNode(!0).firstElementChild;
                C(t, {}, e),
                  E(() => {
                    e.after(t), Se(t);
                  }),
                  (e._x_currentIfEl = t),
                  (e._x_undoIf = () => {
                    xe(t, (e) => {
                      e._x_effects && e._x_effects.forEach(l);
                    }),
                      t.remove(),
                      delete e._x_currentIfEl;
                  });
              })()
            : e._x_undoIf && (e._x_undoIf(), delete e._x_undoIf);
        })
      ),
        r(() => e._x_undoIf && e._x_undoIf());
    }),
    Y("id", (e, { expression: t }, { evaluate: n }) => {
      n(t).forEach((t) =>
        (function (e, t) {
          e._x_ids || (e._x_ids = {}), e._x_ids[t] || (e._x_ids[t] = hn(t));
        })(e, t)
      );
    }),
    ae(re("@", Z("on:"))),
    Y(
      "on",
      ze((e, { value: t, modifiers: n, expression: r }, { cleanup: i }) => {
        let o = r ? B(e, r) : () => {};
        "template" === e.tagName.toLowerCase() &&
          (e._x_forwardEvents || (e._x_forwardEvents = []),
          e._x_forwardEvents.includes(t) || e._x_forwardEvents.push(t));
        let a = gn(e, t, n, (e) => {
          o(() => {}, { scope: { $event: e }, params: [e] });
        });
        i(() => a());
      })
    ),
    kn("Collapse", "collapse", "collapse"),
    kn("Intersect", "intersect", "intersect"),
    kn("Focus", "trap", "focus"),
    kn("Mask", "mask", "mask"),
    Ze.setEvaluator(V),
    Ze.setReactivityEngine({
      reactive: cn,
      effect: function (e, t = Qe) {
        (function (e) {
          return e && !0 === e._isEffect;
        })(e) && (e = e.raw);
        const n = (function (e, t) {
          const n = function () {
            if (!n.active) return e();
            if (!ht.includes(n)) {
              vt(n);
              try {
                return bt.push(yt), (yt = !0), ht.push(n), (Ye = n), e();
              } finally {
                ht.pop(), wt(), (Ye = ht[ht.length - 1]);
              }
            }
          };
          return (
            (n.id = gt++),
            (n.allowRecurse = !!t.allowRecurse),
            (n._isEffect = !0),
            (n.active = !0),
            (n.raw = e),
            (n.deps = []),
            (n.options = t),
            n
          );
        })(e, t);
        return t.lazy || n(), n;
      },
      release: function (e) {
        e.active &&
          (vt(e), e.options.onStop && e.options.onStop(), (e.active = !1));
      },
      raw: dn,
    });
  var An = Ze;
  (window.Alpine = An), An.start();
  var On = {
    updateQuantity: function (e, t) {
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ quantity: t, line: e }),
      })
        .then(function (e) {
          return e.json();
        })
        .then(function (e) {
          window.dispatchEvent(new Event("cart-updated"));
        })
        .catch(function (e) {
          console.error("Error:", e);
        });
    },
  };
  window.Sunrise = On;
})();
